jQuery(document).ready(function($){
    var len = $('.featured-collection-product').length;
    $('.featured-collection-product').each(function(index){
      var $this       = $(this);             
      var colorSwiper = $this.find('.product-slideshow-per-color');
      var colorToggle = $this.find('.product-color-variants');
      var productSlideShow = $this.find('.product-image-slideshow');
      
      var colorSwiperSlide = new Swiper(colorSwiper, {
        slidesPerView: 1,
        speed: 1,
        loop:false,
        autoplay: false,
        allowTouchMove:false,
        fadeEffect: {
          crossFade: true
        }
      });
      
      var productSlideShow = new Swiper(productSlideShow, {
        slidesPerView: 1,
        speed: 1000,
        loop:false,
        autoplay: false,
        watchOverflow:true,
        noSwiping: false,
        noSwipingClass: productSlideShow,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {

            767: {
                slidesPerView: 1,
                noSwiping: true,
                //noSwipingClass: productSlideShow,
            },
        }
      });
      
      colorToggle.find('.color').each(function(index) {
        $(this).click(function(){
          colorToggle.find('.active').removeClass('active');
          colorSwiperSlide.slideTo(index);
          $(this).addClass('active');
          
          
        });
      });
      
      colorSwiperSlide.on('slideChangeTransitionStart', function (e) {
        var swiperActiveSlider = colorSwiper.find('.color-slide.swiper-slide-active');
        var colorVariant      = swiperActiveSlider.data('color-variant');
        var variant_id = swiperActiveSlider.data('variant-id');
        var variant_url = swiperActiveSlider.data('variant-url');
        var price = swiperActiveSlider.data('price');
        var saleprice = swiperActiveSlider.data('sale-price');
		
        if ( saleprice ) {
        	var htmlprice = '<span class="orginal red">'+price+'</span> <span class=" sale">'+saleprice+'</span>';
        } else {
        	var htmlprice = '<span class="orginal">'+price+'</span>';
        }
        
        
        $this.find('.product-color em').text(colorVariant);
        $this.find('.variant-url').attr('href',variant_url);
        $this.find('.variant-id').val(variant_id);
        $this.find('.product-price').html(htmlprice);
        
        $this.find('.swiper-slide').each(function(){
            var dimg = $(this).find('img');
        	var dsrc = dimg.data('src');
          
          	dimg.attr('src',dsrc);
      	});
      });
	  
      // Image Optimization
      var $preload = $this.find('.pre-load-images');
      $preload.find('.swiper-slide').each(function(){
            var dimg = $(this).find('img');
        	var dsrc = dimg.data('src');
          
          	dimg.attr('src',dsrc);
      });
    });

  $('.featured-collection-product.hide_mobile').parent('.featured-collection-column').addClass('hide_mobile');


  });


jQuery(document).ready(function($){
  /*
  $('.announcement-bar').click(function(){
    $('.announcement-popup').show();
    $('body').addClass('body-fixed');
  });
  $('.announcement-popup .close-btn').click(function(){
    $('.announcement-popup').hide();
    $('body').removeClass('body-fixed');
  }); 

  
  
  $('.header-wrap li.has-child:has(.child)').addClass('plussign');
  
  $('.header-mob li.has-child:has(.child)').addClass('plussign-mobile');
  
  $('.menu').addClass('plussign');
  

  $('.menu a').click(function(){ 
    $(this).toggleClass('addminus');
  });

  $('.menu').click(function(){
    $('.header-mob').toggleClass('show-menu');
  });
  
  $('.menu').click(function(){
    if ( $('.search-mob').hasClass('search-mob-show') ) {
      $('.search-mob').removeClass('search-mob-show');
    } 
  });
  
  $('.trigger-search-mob').click(function(){
    if ( $('.header-mob').hasClass('show-menu') ) {
      $('.header-mob').removeClass('show-menu');
    } 
  });
  
  $('.trigger-search-desktop').click(function(){
    $('.search-desktop .search-form').toggleClass('hide-search');
  });
  
  $('.trigger-search-mob').click(function(){
    $('.search-mob').toggleClass('search-mob-show');
  });
  

  $('.header-mob li.plussign-mobile a').click(function(){ 
    if ( $(this).hasClass('addminus') ) {
      $(this).toggleClass('addminus');
    } else {
      $(this).toggleClass('addminus');
    }
    $('.header-mob li.plussign-mobile a').not($(this)).removeClass('addminus');
  });
  
  
  $('.header-mob .plussign-mobile').click(function(){
    if ( $(this).hasClass('show') ) {
      $(this).removeClass('show');
    } else {
      $(this).addClass('show');
    }
    $('.header-mob .plussign-mobile').not($(this)).removeClass('show');

    var siblings = $(this).siblings();
    siblings.toggleClass('gray');

    if ( $(this).hasClass('gray') ) {
      $(this).removeClass('gray');
      siblings.addClass('gray');
    }
  });*/
  
  
  
  $('.discount-off').each(function(index){
    var $PP = $(this).data('pp');
    var $CC = $(this).data('cc');
    var $frac =  $CC / $PP;
    var $perc = ($frac * 100) - 100;
    var pos = parseInt(Math.round($perc) );
    $(this).html(Math.abs(pos)+'% OFF');
  });
  
});